import React, { Component } from 'react'
import i18next from 'i18next';
import ApiBase from '../lib/ApiBase';
import ActivationImg from '../Assets/Image/300-300_Hosgeldiniz.png';

export default class ActivationPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      message: "",
      actLoading: false
    }
  }

  componentDidMount() {
    this.getActivationData();
  }

  getActivationData = () => {
    this.setState({ actLoading: true })
    const _guid = this.props.match.params.guid;
    // console.log(_guid)
    ApiBase.Post({
      url: '/get-activation-data',
      data: {
        Guid: _guid
      },
      successFunction: (e) => {
        // console.log(e.data)
        this.setState({ actLoading: false, message: e.data.message });
        // this.setState({ loading: false })
      },
      errorFunction: (e) => {
        // console.log(e.data)
        this.setState({ actLoading: false, message: e.data.message });

      }
    })
  }
  render() {
    return (
      <div className="ActivationPage">
        <div className="container ">
          <div className="ActivationPage__Body d-flex flex-column">
            <div className=" text-center my-auto">
              {/* <img src={ActivationImg} className="img-fluid"></img> */}
              {this.stateactLoading !== true &&
                <h4 className="text-center h-size-4 mt-4 "> {this.state.message} </h4>}
              <div className="row">
                <div className=" col-lg-2 mx-auto py-3 ">
                  <a className="submit-button" href={`/${localStorage.getItem("lang")}/`}>{i18next.t("Home")}</a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
}
